
<template lang="pug">
  .subscription
    .subscription-title
      p {{ get_date }}
    .block
      .col
        img( v-if="image" :src="image()" )
      .col
        b {{ subscription.product_title }}
        br
        | ${{ subscription.price }}
        span( v-if="subscription.quantity > 1") {{ ' x ' + subscription.quantity }}
        br
        | Every {{ subscription.order_interval_frequency }} Days
      .col
        button.btn--primary( v-if="buttons" @click.prevent="edit" ) Edit
        button.btn--primary( v-if="buttons" @click.prevent="cancel" ) Cancel
</template>

<script>
  export default {
    name: 'Subscription',

    components: {
    },

    props: {
      subscription: Object,
      buttons: Boolean
    },

    setup() {
    },

    async mounted() {
    },

    data() {
      return {
      }
    },

    validations () {
      return {
      }
    },

    computed: {
      get_date: function() {
        const d = new Date(this.subscription.next_charge_scheduled_at);
        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return `${this.buttons ? '' : 'Your upcoming order on'} ${monthNames[d.getMonth()]} ${d.getDate()}, ${d.getYear() + 1900}`;
      },
    },

    methods: {
      image: function() {
        const products = this.$parent.$parent.products || this.$parent.products;
        const productId = this.subscription.external_product_id.ecommerce;
        const productInfo = products[productId];
        return productInfo ? productInfo.image : null;
      },

      edit: function() {
        this.$parent.edit(this.subscription);
      },

      cancel: function() {
        this.$parent.cancel(this.subscription);
      }
    }
  }
</script>

<style scoped lang="scss">
.subscription-edit .subscription-title p {
  margin: 1.25rem 0;
  font-weight: bold;
  text-transform: uppercase;
}

.subscription {
  .block {
    display: flex;
    padding: 4px 12px;
    border: 1px solid black;
    align-items: center;
  }

  .col {
    padding: 4px;
  }

  .col:first-child {
    width: 20%;
  }

  .col:nth-child(2) {
    width: 60%;
  }

  .col:last-child {
    width: 20%;
  }

  .col img {
    display: block;
    width: 100%;
    height: auto;
    max-width: 200px;
  }

  .col button:first-child {
    margin-bottom: 4px;
  }
}
</style>
